var en = function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return (n10 == 1 && n100 != 11) ? 'one'
      : (n10 == 2 && n100 != 12) ? 'two'
      : (n10 == 3 && n100 != 13) ? 'few'
      : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
};
var select = function (value, data) {
  return {}.hasOwnProperty.call(data, value) ? data[value] : data.other;
};
var number = function (value, name, offset) {
  if (!offset) return value;
  if (isNaN(value)) throw new Error("Can't apply offset:" + offset + ' to argument `' + name + '` with non-numerical value ' + JSON.stringify(value) + '.');
  return value - offset;
};
var plural = function (value, offset, lcfunc, data, isOrdinal) {
  if ({}.hasOwnProperty.call(data, value)) return data[value];
  if (offset) value -= offset;
  var key = lcfunc(value, isOrdinal);
  return key in data ? data[key] : data.other;
};
var fmt = {
  lowercase: v => v.toLowerCase()
};

module.exports = {
  errorBoundary: {
    title: function(d) { return "Oops, something's not right"; },
    message: function(d) { return "Contact Customer Care" + select(d.customerCareNumber, { undefined: "", other: " at " + d.customerCareNumber }) + " for help placing your order"; }
  },
  titles: {
    mr: function(d) { return "Mr"; },
    ms: function(d) { return "Ms"; },
    mrs: function(d) { return "Mrs"; },
    sir: function(d) { return "Sir"; },
    miss: function(d) { return "Miss"; },
    dr: function(d) { return "Dr"; },
    lord: function(d) { return "Lord"; },
    lady: function(d) { return "Lady"; },
    prof: function(d) { return "Prof"; },
    rev: function(d) { return "Rev"; },
    other: function(d) { return "Other"; }
  },
  months: {
    january: function(d) { return "January"; },
    february: function(d) { return "February"; },
    march: function(d) { return "March"; },
    april: function(d) { return "April"; },
    may: function(d) { return "May"; },
    june: function(d) { return "June"; },
    july: function(d) { return "July"; },
    august: function(d) { return "August"; },
    september: function(d) { return "September"; },
    october: function(d) { return "October"; },
    november: function(d) { return "November"; },
    december: function(d) { return "December"; }
  },
  basket: {
    title: function(d) { return "Shopping Bag"; },
    items: function(d) { return plural(d.numItems, 0, en, { "1": "1 item", other: number(d.numItems, "numItems") + " items" }); },
    remove: function(d) { return ""; },
    moveToWishlist: function(d) { return ""; },
    removeSuccess: function(d) { return "You have removed " + plural(d.items, 0, en, { "1": "1 item", other: number(d.items, "items") + " items" }); },
    moveToWishlistSuccess: function(d) { return select(d.name, { undefined: "Item has been moved to your Wish List", other: "You have moved " + plural(d.items, 0, en, { "1": "1 item", other: number(d.items, "items") + " items" }) + "to your Wish List" }); },
    alreadyInWishlist: function(d) { return "This is already in your Wish List"; },
    undo: function(d) { return "Undo"; },
    quantity: function(d) { return "Quantity"; },
    continueShopping: function(d) { return "Continue Shopping"; },
    proceedToPurchase: function(d) { return "Proceed To Checkout"; },
    empty: function(d) { return "Add items to your Shopping Bag"; },
    continueLink: function(d) { return "Shop Just In"; },
    soldout: {
      itemsCount: function(d) { return "Currently unavailable (" + d.items + ")"; },
      outOfStock: function(d) { return "Sorry, we’ve removed one or more of the items in your Shopping Bag as they've sold out."; }
    },
    review: function(d) { return "Review"; },
    orderSummaryTitle: function(d) { return "Order Summary"; },
    moveAllToWishlist: function(d) { return "Add All To Wish List"; },
    removeAll: function(d) { return "Remove All"; },
    removeAllFromBasket: {
      title: function(d) { return "Remove All"; },
      description: function(d) { return "Are you sure you want to remove all items?"; },
      remove: function(d) { return "Remove"; },
      cancel: function(d) { return "Cancel"; }
    },
    reservation: function(d) { return "Reservation request"; },
    quantityStepperError: function(d) { return "The requested quantity cannot be added to the Shopping Bag"; },
    removedItemsMessage: {
      soldOut: function(d) { return "One or more items have been removed from your Shopping Bag as they are sold out. Add them to your Wish List and we will notify you should they become available again."; },
      restrict: function(d) { return "One or more items have been removed from your Shopping Bag as they can’t be shipped to your country. Please ensure the country site you are browsing matches your delivery address."; },
      unavailable: function(d) { return "One or more items have been removed from your Shopping Bag as they are currently unavailable in your country."; }
    },
    legalMessage: function(d) { return "For a limited period of time, the products purchased on theoutnet.com will be sold by YOOX NET-A-PORTER GROUP S.p.A. Please see the Terms and Conditions for more information."; },
    loadingOverlay: {
      firstMessage: function(d) { return "Please do not leave the page"; },
      secondMessage: function(d) { return "We are taking you back to THE OUTNET to complete the purchase"; }
    },
    partiallyRectMsg: function(d) { return "This item has had its quantity reduced"; },
    applePay: {
      title: function(d) { return "Apple Pay"; },
      payWith: function(d) { return "Pay With"; }
    }
  },
  addressForm: {
    save: function(d) { return "Save Address"; },
    dduInfo: function(d) { return "By placing my order, I accept to pay any applicable taxes and/or duties when my purchase arrives at customs."; },
    acceptAdditionalCosts: function(d) { return "I agree to pay any applicable taxes and/or import duties"; },
    select: function(d) { return "Select " + fmt.lowercase(d.select, "en"); },
    display: {
      addAlternatePhone: function(d) { return "Add alternate phone"; },
      city: function(d) { return "City"; },
      country: function(d) { return "Country"; },
      personTitle: function(d) { return "Title"; },
      firstName: function(d) { return "First name"; },
      lastName: function(d) { return "Last name"; },
      addressLine_1: function(d) { return "Address line one"; },
      addressLine_2: function(d) { return "Address line two"; },
      addNewLine: function(d) { return "Add new line"; },
      cityTownVillage: function(d) { return "City/Town/Village"; },
      streetName: function(d) { return "Street Name"; },
      buildingName: function(d) { return "Building Name"; },
      district: function(d) { return "District"; },
      county: function(d) { return "County"; },
      pronunciationFirstName: function(d) { return "Pronunciation First Name"; },
      pronunciationLastName: function(d) { return "Pronunciation Last Name"; },
      phone: function(d) { return "Phone number"; },
      alternatePhone: function(d) { return "Alternate number"; },
      province: function(d) { return "Province"; },
      state: function(d) { return "State"; },
      region: function(d) { return "Region"; },
      area: function(d) { return "Area"; },
      zipCode: function(d) { return "ZIP code"; },
      postCode: function(d) { return "Postcode"; },
      eircode: function(d) { return "Eircode"; },
      pccc: function(d) { return "PCCC"; },
      taxId: function(d) { return "Tax ID"; },
      addressFinder: function(d) { return "Start typing your address or postcode/ZIP"; }
    },
    addressFinder: {
      enterManually: function(d) { return "Enter address manually"; },
      searchAnother: function(d) { return "Search for another address"; },
      keepTyping: function(d) { return "Keep typing to display more results below"; },
      goBack: function(d) { return "Back to results"; },
      nonLatinError: function(d) { return "Please use latin characters or enter address manually"; }
    },
    help: {
      pccc: function(d) { return "Enter your PCCC number (e.g. P + 12 digits)"; },
      taxId: function(d) { return "Your Indonesian TAX ID (NPWP) number is required for your shipment to clear Indonesian customs."; },
      Eircode: function(d) { return "e.g. A65 F4E2"; }
    }
  },
  purchasePath: {
    timeline: {
      shipping: function(d) { return "Shipping"; },
      reviewAndPay: function(d) { return "Review & Pay"; },
      complete: function(d) { return "Complete"; }
    },
    orderSummaryTitle: function(d) { return "Order Summary"; },
    continueToNextStep: function(d) { return "Continue To Next Step"; },
    items: function(d) { return "My Bag (" + plural(d.numItems, 0, en, { "1": "1 item", other: number(d.numItems, "numItems") + " items" }) + ")"; },
    stickyBagButton: function(d) { return "Review"; },
    edit: function(d) { return "Edit"; },
    stickyBagTitle: function(d) { return "Your Order Details"; },
    paymentProcessing: function(d) { return "We’re processing your payment - nearly done!"; },
    languageCheckoutPrompt: function(d) { return "Please enter the following fields in English"; },
    liveChatHeader: function(d) { return "Need help?"; },
    liveChatOffline: function(d) { return "Chat offline, try again later"; },
    errorPopup: function(d) { return "Please complete your purchase at Checkout."; }
  },
  cartRectification: {
    outOfStock: {
      primary: function(d) { return "Okay, return to " + select(d.allItemsOutOfStock, { true: "shopping bag", other: "checkout" }); },
      title: function(d) { return "Items sold out"; },
      description: function(d) { return "Sorry, we’ve removed " + select(d.allItemsOutOfStock, { true: "all of the", other: "one or more of the" }) + " items in your Shopping Bag as they have sold out. " + select(d.loggedIn, { true: "Add them to your Wish List and we’ll notify you should they become available again.", other: "" }); }
    },
    shippingRestricted: {
      primary: function(d) { return "Remove Restricted Items"; },
      secondary: function(d) { return "Edit Shipping Address"; },
      title: function(d) { return "Restricted Items"; },
      description: function(d) { return "Sorry, the below can't be delivered to your address"; }
    },
    bagUpdated: function(d) { return "Your Shopping Bag has been updated"; },
    CART_ITEM_INVALID: function(d) { return "Sorry, one or more of your items are no longer available to purchase"; },
    CART_MERGED: function(d) { return "As you’ve signed into your account, we’ve updated your Shopping Bag to include the items you added as a guest"; },
    PAYMENT_METHOD_INVALID_COD_LIMIT: function(d) { return "Sorry, the value of your Shopping Bag exceeds the limit for Cash on Delivery purchases. We’ve updated your Payment options"; },
    PAYMENT_METHOD_INVALID_COD_LOCATION: function(d) { return "Sorry, Cash on Delivery isn’t available for this location. We’ve updated your Payment options"; },
    wishlist: function(d) { return "Add to Wish List"; }
  },
  addressSelectionForm: {
    add: function(d) { return "Add A New Address"; },
    addAddress: function(d) { return "Add Address"; },
    edit: function(d) { return "Edit"; },
    addressId: function(d) { return "Shipping Address"; },
    submit: function(d) { return "Continue"; },
    shippingTo: function(d) { return "Shipping to"; }
  },
  creditCardForm: {
    number: function(d) { return "Card Number"; },
    cardHolderName: function(d) { return "Name On Card"; },
    expiryDate: function(d) { return "Expiry Date"; },
    month: function(d) { return "Month"; },
    monthPlaceholder: function(d) { return "MM"; },
    year: function(d) { return "Year"; },
    cardDetails: function(d) { return "Card details"; },
    yearPlaceholder: function(d) { return "YY"; },
    cvv: function(d) { return d.cvvType; },
    cvvHelp: function(d) { return plural(d.cvvSize, 0, en, { "0": "Security code ", other: number(d.cvvSize, "cvvSize") + " numbers" }) + " on the " + select(d.cvvType, { CID: "front", other: "back" }) + " of your card"; },
    saveCard: function(d) { return "Save card for future use"; },
    submit: function(d) { return "Save"; },
    cvvTitle: function(d) { return "Please enter your CVV"; },
    completeYourPurchase: function(d) { return "Complete your purchase"; }
  },
  considered: {
    badge: function(d) { return "Considered"; },
    consideredDelivery: function(d) { return "This is currently the delivery option with the lowest carbon footprint"; },
    consideredInfo: {
      consideredShipping: {
        title: function(d) { return "Delivery"; },
        subTitle: function(d) { return "Concerned about the environmental impact of your delivery? Don't worry, we'll offset this for you through our carbon credits programme."; },
        recycleInformation: function(d) { return "You can easily recycle almost all of our packaging at home."; }
      },
      consideredPackaging: {
        title: function(d) { return "Packaging"; },
        packagingInformation: function(d) { return "You can easily recycle almost all of our packaging at home. Although stickers and returns labels aren't currently recyclable, we're exploring responsible alternatives. Our hangers and garment bags are also non-recyclable, but we'd encourage you to re-use these if you receive them!"; },
        careGuide: function(d) { return "For tips on how to care for your items, take a look at our  "; },
        actionText: function(d) { return "Care Guide "; },
        href: function(d) { return "/editorial/how-to-wash-clothes/"; }
      }
    }
  },
  finishingTouches: {
    title: function(d) { return "Accessories to Match"; },
    refresh: function(d) { return "Refresh"; }
  },
  registrationForm: {
    register: function(d) { return "Register"; },
    logonId: function(d) { return "Email address"; },
    logonPassword: function(d) { return "Create New Password"; },
    personTitle: function(d) { return "Title"; },
    firstName: function(d) { return "First Name"; },
    lastName: function(d) { return "Last Name"; },
    phone1: function(d) { return ""; },
    dateOfBirth: function(d) { return ""; },
    day: function(d) { return "Day"; },
    month: function(d) { return "Month"; },
    year: function(d) { return "Year"; },
    receiveEmailPreference: function(d) { return "Want to remain stylishly in the know? Sign up for email updates"; },
    maMarketingConsent: function(d) { return "Subscribe to exclusive THE OUTNET and other LuxExperience B.V. brands content to receive 10% off your next THE OUTNET order."; },
    discountDisclaimer: function(d) { return "[Exclusions apply - see T&Cs](https://www.theoutnet.com/page/policies/general-terms-and-conditions-of-sale/#promotional-codes)."; },
    emailReadMore: function(d) { return "What will I receive?"; },
    marketingYes: function(d) { return "Yes please!"; },
    marketingNo: function(d) { return "No thanks"; },
    selectTitle: function(d) { return "Select Title"; },
    other: function(d) { return "Other..."; },
    privacyPolicy: function(d) { return "Learn more about our "; },
    privacyPolicyTitle: function(d) { return "Privacy Policy"; },
    termsAndConditions: function(d) { return "By registering you agree to our "; },
    termsAndConditionsLink: function(d) { return "Account Terms and Conditions"; },
    marketingError: function(d) { return "Please select an option to complete your registration"; },
    emailInfo: function(d) { return "By ticking the checkbox, you will sign up to THE OUTNET and other LuxExperience B.V.* brands email marketing communications containing the newest arrivals at exceptional prices, expert styling advice, our latest (and best) promotions.\n\nYou can opt out at any time by managing your preferences in your account or by following the instructions provided in each communication.\n\n*LuxExperience B.V. includes the following brands: Mr Porter, Mytheresa, Net-A-Porter, The Outnet, YOOX.\n\nWhen you visit, use our websites and/or applications, including services provided thereon, your information will be processed in accordance with the respective Privacy Policy of each brand: [Mr Porter](https://www.mrporter.com/content/help/privacy-policy/), [Mytheresa](https://www.mytheresa.com/to/service/privacy-policy), [Net-A-Porter](https://www.net-a-porter.com/content/help/privacy-policy/), [The Outnet](https://www.theoutnet.com/page/policies/privacy-policy/), [YOOX](https://www.yoox.com/Legal/Privacypolicy)."; },
    emailTitle: function(d) { return "Our Emails"; },
    genderMens: function(d) { return "Men"; },
    genderWomens: function(d) { return "Women"; },
    genderAll: function(d) { return "All"; },
    genderSelectionLabel: function(d) { return "Please select your preference"; },
    gdprConsentTerms: function(d) { return "I agree to the [Account Terms and Conditions](https://www.theoutnet.com/" + d.locale + "/page/policies/account-terms-and-conditions/)."; },
    gdprConsentPrivacy: function(d) { return "Personal data provided by you will be processed for account registration purposes in accordance with our [Privacy Policy](https://www.theoutnet.com/" + d.locale + "/page/policies/privacy-policy/)."; },
    gdprConsentError: function(d) { return "Required field"; },
    checkAll: function(d) { return "Check all"; },
    ageConsent: function(d) { return "I confirm that I am 14 years old or older (mandatory)"; },
    tcConsent: function(d) { return "Consent to [the collection and use of personal information]() (mandatory)"; },
    newsletterConsent: function(d) { return "[I consent to the collection and use of my personal information]() for marketing purposes in order to be updated via email on news, latest arrivals, promotional initiatives of THEOUTNET and other LuxExperience B.V. brands as part of our targeted marketing activities (optional)"; },
    termsAndConditionsAcceptance: function(d) { return "By registering you accept you have read and understood THE OUTNET [Account Terms and Conditions](https://www.theoutnet.com/" + d.locale + "/page/policies/account-terms-and-conditions/) and [Privacy Policy](https://www.theoutnet.com/" + d.locale + "/page/policies/privacy-policy/).\n\nBy clicking Register, you agree to join our Rewards Programme as regulated under these [Terms and Conditions](https://www.theoutnet.com/" + d.locale + "/page/policies/general-terms-and-conditions-of-sale/#outnet-rewards) and enjoy the additional benefits listed in [My Account Terms and Conditions](https://www.theoutnet.com/" + d.locale + "/page/policies/account-terms-and-conditions/)."; }
  },
  errors: {
    invalidPhoneNotification: function(d) { return "Please enter your phone number in international format (e.g. +447700900123)"; },
    invalidPhoneFormat: function(d) { return "Please enter your phone number in international format (e.g. +447700900123)"; },
    unknown: function(d) { return "Oops, something's not right. Try again later."; },
    generic: function(d) { return "Oops, something's not right. Try again later."; },
    global: function(d) { return "Oops, something's not right. Try again later."; },
    required: function(d) { return select(d.selectMessageField, { phone1: "Enter your mobile number to receive an SMS update on your delivery", other: select(d.field, { undefined: "Required", other: d.field + " is required" }) }); },
    phoneRequired: function(d) { return "Enter your mobile number to receive an SMS update on your delivery"; },
    invalid: function(d) { return "Invalid " + d.field + " provided"; },
    invalidPccc: function(d) { return select(d.field, { TAX_ID: "Please enter a valid TAX ID", PCCC: "Enter your PCCC number (e.g. P + 12 digits)", other: "Invalid " + d.name + " provided" }); },
    invalidState: function(d) { return "Invalid State provided"; },
    invalidZipCode: function(d) { return "Invalid ZIP code provided"; },
    maxLength: function(d) { return "Must be " + d.characters + " characters or less"; },
    minLength: function(d) { return "Must be " + d.characters + " characters or more"; },
    containsWhitespace: function(d) { return "Contains whitespace"; },
    characterOccurrence: function(d) { return "Your password must not contain a character that is used more than " + d.occurrence + " times"; },
    containsLogonId: function(d) { return "Your password can't contain your email address"; },
    containsPassword: function(d) { return "Password cannot contain the word password"; },
    limitExceeded: function(d) { return "Limit exceeded"; },
    authenticationError: function(d) { return "The details you've provided aren't correct"; },
    loginNotAllowed: function(d) { return "Sorry, you'll need to wait " + d.time + " " + d.timeUnit + " before you can sign in again."; },
    timeUnit: function(d) { return select(d.type, { HOURS: "hours", MINUTES: "minutes", SECONDS: "seconds", other: "" }); },
    mustContainNumber: function(d) { return "Your password must contain at least " + plural(d.occurrence, 0, en, { one: "one number", other: number(d.occurrence, "occurrence") + " numbers" }); },
    mustContainLetter: function(d) { return "Your password must contain at least " + plural(d.occurrence, 0, en, { one: "one letter", other: number(d.occurrence, "occurrence") + " letters" }); },
    mustContainUppercase: function(d) { return "Your password must contain at least one uppercase letter"; },
    passwordsMatch: function(d) { return "Your new password must be different from your old password"; },
    reuseOldPassword: function(d) { return "It looks like you've used this password before. Enter a new one"; },
    blocklistedPassword: function(d) { return "Sorry, you can't use that password"; },
    paymentCancelled: function(d) { return "Sorry, your payment has been cancelled but don't worry, you weren't charged. Try again or choose another payment method."; },
    paymentFailed: function(d) { return "Sorry, we were unable to authorise your payment. Please try again or select an alternate payment method"; },
    promotionCodeInvalid: function(d) { return "Oops, something's not right. Please check the promo code and try again"; },
    promotionCodeLimitExceeded: function(d) { return "Sorry you can only apply 2 promo codes"; },
    promoNotApplied: function(d) { return "Sorry, this promo doesn't apply to your Shopping Bag"; },
    promotionCodeDuplicated: function(d) { return "Promotion code is already applied"; },
    promotionNotAvailableAtThisTime: function(d) { return "Promotion cannot be applied at this time, try later"; },
    promotionCodeInUse: function(d) { return "Promotion code already in use"; },
    promotionExpired: function(d) { return "Promotion has expired"; },
    promotionOverallLimitExceeded: function(d) { return "Promotion limit exceeded"; },
    guestSessionExpired: function(d) { return "Your checkout session has expired, please try again."; },
    cardNotSupported: function(d) { return "Sorry, this payment option is currently unavailable."; },
    pcccRequired: function(d) { return "Enter your PCCC number (e.g. P + 12 digits)"; },
    zipCodeDoesNotMatchState: function(d) { return "Please check your " + d.zip; },
    maxWishList: function(d) { return "You've reached the maximum number of items in your Wish List. Remove some items from your Wish List and try again"; },
    invalidCharacters: function(d) { return "Sorry, we're unable to accept " + d.nonLatin; },
    notMatchDropdown: function(d) { return "Please select an option from the list"; },
    regexMismatch: function(d) { return "Sorry, this format isn't valid"; },
    personTitleMismatch: function(d) { return "Please select a title from the list"; },
    klarnaExpress: function(d) { return "Sorry, your purchase with Klarna Express has not been successful. You will be redirected to the THE OUTNET Checkout page to place your order"; },
    userExists: function(d) { return "User already exists"; },
    eircode: function(d) { return "Must be a 7-character alpha-numeric code, e.g. A65 F4E2. For information visit www.eircode.ie"; },
    apAddress: function(d) { return "Please add the correct address in your Apple Pay Wallet"; }
  },
  retry: {
    title: function(d) { return "We're sorry, there was an error loading the shopping bag."; },
    retrynow: function(d) { return "Retry now"; },
    timetoretry: function(d) { return "We'll try and reconnect you in " + d.seconds + " seconds..."; },
    retryingnow: function(d) { return "Retrying now"; }
  },
  notifications: {
    promoCodeApplied: function(d) { return "We've automatically updated your Shopping Bag with your promos"; },
    promoCodeRemoved: function(d) { return "Your promo has been removed. We’ve updated your Shopping Bag"; },
    promotionValid: function(d) { return "Promotion is valid"; },
    ADD_TO_BAG_MESSAGE_ERROR: function(d) { return "Sorry, this item wasn’t added to your Shopping Bag. Please try again"; },
    ERR_ORDER_NOT_READY_CHECKOUT: function(d) { return "Sorry, your purchase hasn't been successful. Please check your details and review your Shopping Bag before completing payment or contact Customer Care for assistance in placing an order"; },
    WISHLIST_SUCCESSFULLY_RENAMED: function(d) { return "Your Wish List has been renamed"; },
    WISHLIST_SUCCESSFULLY_SHARED: function(d) { return "Your Wish List has been shared"; },
    WISHLIST_SUCCESSFULLY_UNSHARED: function(d) { return "Your Wish List has been unshared"; },
    FAILED_SHARE_WISHLIST: function(d) { return "Failed Share Wish List"; },
    FAILED_UNSHARE_WISHLIST: function(d) { return "Failed Unshare Wish List"; },
    WISHLIST_SUCCESSFULLY_CREATED: function(d) { return "Your Wish List has been created"; },
    WISHLIST_SUCCESSFULLY_REMOVED: function(d) { return "Your " + d.name + " Wish List has been removed"; },
    WISHLIST_FAILED_TO_REMOVE: function(d) { return select(d.error, { ERR_WISH_LIST_NOT_EXISTS: "This Wish List doesn't exist", other: "Your Wish List wasn't removed. Please try again" }); },
    DUPLICATE_ITEM_TO_CREATE: function(d) { return "This item is already in your Wish List"; },
    WISHLIST_MAX_WISHLIST_ITEMS_REACHED: function(d) { return "You've reached the maximum number of items in your Wish List. Remove some items from your Wish List and try again"; },
    FETCH_WISH_LIST_ERROR: function(d) { return select(d.error, { ERR_WISH_LIST_NOT_EXISTS: "This Wish List doesn't exist", other: "Couldn't get the Wish List" }); },
    FAILED_REMOVE_ITEM: function(d) { return "Sorry, this item wasn't removed. Please try again"; },
    ERR_SKU_ALREADY_EXISTS: function(d) { return "One or more of these items are already in your Wish List"; },
    shippingRestricted: function(d) { return "Unfortunately we cannot ship to this address due to restricted items in your order. To carry on with your purchase, please change your shipping address."; },
    errors: function(d) { return select(d.error, { ADD_TO_WISHLIST_NO_SIZE_SELECTED_ERROR: " Please select a size.", CART_ITEM_INSUFFICIENT_STOCK: "Sorry, we don't have any more of this item available", ERR_SKU_ALREADY_EXISTS: "This item is already in your Wish List", ERR_WISH_LIST_NOT_EXISTS: "This Wish List doesn't exist", ERR_WISH_LIST_NAME_ALREADY_EXISTS: "Wish List name already exists", ERR_WISH_LIST_MAX_WISH_LISTS_REACHED: "You've reached the maximum number of Wish Lists. Remove a Wish List to create a new one", ERR_WISH_LIST_MAX_WISH_LIST_ITEMS_REACHED: "You've reached the maximum number of items in your Wish List. Remove some styles to add items again", NO_SIZE_SELECTED_ERROR: " Please select a size. ", _ERR_GENERIC: "Sorry, this item wasn’t added to your Shopping Bag. Please try again.", CART_ITEM_OUT_OF_STOCK: "Sorry, this item has sold out", GENERIC_ERROR: "Unable to perform your request. Please try again.", TEMPORARY_ADD_TO_CART_ERROR: "Sorry, this item wasn't added to your Shopping Bag. Please try again.", ADD_TO_CART_IDENTITY_GENERIC_ERROR: " Sorry, this item wasn't added to your Shopping Bag. Please try again. ", ADD_TO_CART_GENERIC_ERROR: " Sorry, this item wasn't added to your Shopping Bag. Please try again. ", other: "Unable to perform your request. Please try again." }); },
    hazmat: function(d) { return "Shipping restrictions may apply"; },
    finalSale: function(d) { return "Final Sale. This item is non-returnable"; },
    ERR_WISH_LIST_MAX_WISH_LIST_ITEMS_REACHED: function(d) { return "You've reached the maximum number of items in your Wish List. Remove some items from your Wish List and try again"; },
    shippingDateCutOffExceeded: {
      newDate: function(d) { return "Sorry, your previous delivery time is no longer available. Your order will now be shipped with " + d.description + " and delivered on " + d.delivery; }
    }
  },
  guestRegistrationForm: {
    registrationTitle: function(d) { return "Create an account to start enjoying many benefits including:"; },
    benefits: function(d) { return select(d.benefitType, { tracking: "Order tracking", ease: "Easy returns and exchanges", speed: "Faster checkouts", other: "" }); },
    accountDetails: function(d) { return "Enter your account details"; },
    shopNewIn: function(d) { return "Continue shopping"; },
    welcome: function(d) { return "Welcome to THE OUTNET!"; },
    success: function(d) { return "Your account has been successfully created"; },
    viewMyAccount: function(d) { return "Go to My Account"; },
    createPassword: function(d) { return "Choose your password"; },
    password: function(d) { return "Password"; },
    register: function(d) { return "Create Account"; },
    passwordHelp: function(d) { return "Your password must be eight characters or more and contain both an uppercase letter and a number"; }
  },
  lineItem: {
    quantity: function(d) { return "Quantity: "; },
    oneSize: function(d) { return "One Size"; }
  },
  price: {
    discountPercentage: function(d) { return "(-" + d.discountPercentage + "%)"; },
    original: function(d) { return ""; },
    discountApplied: function(d) { return "Discount Applied:"; },
    promoApplied: function(d) { return select(d.description, { undefined: "Promotion applied", other: d.description }); },
    tax: function(d) { return "Tax"; },
    itemTax: function(d) { return select(d.included, { true: "inc. ", other: "" }) + "Tax: "; },
    duties: function(d) { return select(d.included, { true: "inc. ", other: "" }) + "Duties: "; },
    final: function(d) { return ""; },
    salesTax: function(d) { return "Tax: "; },
    showTaxesToggle: function(d) { return select(d.enabled, { true: "Close", other: "Show Breakdown" }); },
    wasPriceOriginal: function(d) { return "RRP: " + d.wasPrice; },
    wasPrice: function(d) { return "RRP:"; },
    originalPrice: function(d) { return "Original price:"; }
  },
  loginOrGuestForm: {
    hasAccountTitle: function(d) { return "Sign In"; },
    hasAccount: function(d) { return "I have an account"; },
    noAccount: function(d) { return "I'd prefer to checkout as guest"; },
    logonId: function(d) { return "Email Address"; },
    submit: function(d) { return select(d.formType, { login: "Proceed to Checkout", registration: "Register", other: "Guest Checkout" }); },
    forgotPassword: function(d) { return "Forgotten your password?"; },
    signInInfoMessage: function(d) { return "We'll send your order confirmation to your email address"; },
    forgotPasswordLinkTitle: function(d) { return "Forgot Password?"; },
    guestCheckout: function(d) { return "If you have a registered account, but are checking out as a guest, you'll need to sign into your account to update your email preferences."; },
    errors: {
      userExists: function(d) { return "It looks like your email address is already registered"; }
    },
    hasAccountDescription: function(d) { return "Checkout faster with saved details"; },
    noAccountTitle: function(d) { return "Guest checkout"; },
    noAccountDescription: function(d) { return "You can create an account later"; },
    createAccountTitle: function(d) { return "Register"; },
    createAccountDescription: function(d) { return "Sign up to THE OUTNET’s promotional emails, and get 10% off your next order"; },
    maMarketingConsent: function(d) { return "Subscribe to exclusive THE OUTNET and other LuxExperience B.V. brands content to receive 10% off your next THE OUTNET order."; },
    discountDisclaimer: function(d) { return "[Exclusions apply - see T&Cs](https://www.theoutnet.com/page/policies/general-terms-and-conditions-of-sale/#promotional-codes)."; },
    emailTitle: function(d) { return "What will I receive?"; },
    continueAsGuest: function(d) { return "Create an Account later? [Continue as Guest]()"; }
  },
  loginForm: {
    logon: function(d) { return "Sign in"; },
    logonId: function(d) { return "Email Address"; },
    logonPassword: function(d) { return "Password"; }
  },
  loginStep: {
    title: function(d) { return "Sign In"; },
    signInOrGuest: function(d) { return "Sign in or checkout as guest"; },
    subTitle: function(d) { return "Please enter your email address"; },
    fastTrackMessage: function(d) { return "You are about to be fast-tracked to order review"; }
  },
  packagingOptions: {
    title: function(d) { return "Packaging and gifting"; },
    zeroPackagingPrice: function(d) { return "Free"; },
    description: {
      signature: function(d) { return "Delivered in a MR PORTER signature white box that’s FSC-certified and recyclable"; },
      basic: function(d) { return "Your order will be delivered in a FSC-certified, recyclable, non-branded box"; }
    },
    submit: function(d) { return "Continue"; },
    errors: {
      outOfJuristdiction: function(d) { return "Cannot use an address outside of your country"; },
      packagingOptionInvalid: function(d) { return "Invalid packaging option"; },
      option: function(d) { return "option"; }
    }
  },
  paymentOptionsForm: {
    title: function(d) { return "Payment"; },
    addCart: function(d) { return "Add a new card"; },
    payPal: function(d) { return "PayPal"; },
    payPalHelp: function(d) { return "You'll be redirected to Paypal to complete your purchase"; },
    payPalBA: function(d) { return "Set up faster payment for future purchases"; },
    klarnaOptions: function(d) { return select(d.type, { KLARNA_PAY_NOW: "Pay now", KLARNA_PAY_LATER: "Pay later", KLARNA_SLICE_IT: "Pay in instalments", KLARNA: "Pay with Klarna", other: "" }); },
    klarnaHelpHeader: function(d) { return select(d.type, { KLARNA_PAY_NOW: "", KLARNA_PAY_LATER: "Pay for your order later with no fees or interest", KLARNA_SLICE_IT: "Pay for your order in interest-free instalments", other: "" }); },
    klarnaHelpInfo: function(d) { return select(d.type, { KLARNA_PAY_NOW: "You’ll be directed to Klarna to complete payment", KLARNA_PAY_LATER: "You’ll be directed to Klarna to complete your purchase and they’ll be in touch when your payment is due", KLARNA_SLICE_IT: "You’ll be directed to Klarna to complete your purchase and they’ll be in touch when your payments are due", KLARNA: "You’ll be redirected to Klarna to complete your purchase and they’ll be in touch when your payments are due.", other: "" }); },
    klarnaHelpReference: function(d) { return select(d.type, { KLARNA_PAY_NOW: "", other: "Please note, Klarna will perform a soft search with a credit reference agency. This will not affect your credit rating" }); },
    affirm: function(d) { return "Affirm"; },
    affirmOptions: function(d) { return select(d.type, { AFFIRM: "Buy now, pay over time", other: "" }); },
    creditCard: function(d) { return "Credit Card"; },
    cashOnDelivery: function(d) { return "Cash on Delivery"; },
    cashOnDeliveryHelp: function(d) { return "If a refund occurs, it will be refunded by bank account transfer. Cash on delivery can be paid by cash, credit card or electronic money."; },
    billingAddress: function(d) { return "Billing Address"; },
    billingAddressLabel: function(d) { return "Bill to"; },
    sameAsShipping: function(d) { return "Same as Shipping Address"; },
    differentAddress: function(d) { return "Choose another Billing Address"; },
    savedCardDigits: function(d) { return "**** " + d.lastFourDigits; },
    savedCardExpiry: function(d) { return "expires " + d.expireMonth + "/" + d.expireYear; },
    savedCardLabel: function(d) { return "**** " + d.lastFourDigits + " expires " + d.expireMonth + "/" + d.expireYear; },
    expiredCardLabel: function(d) { return "Expired " + d.expireMonth + "/" + d.expireYear; },
    expiredCardDigits: function(d) { return "**** " + d.lastFourDigits; },
    submit: function(d) { return "Review My Order"; },
    billingTo: function(d) { return "Billing to " + d.addressLine; },
    paymentMethods: function(d) { return "Payment Methods"; },
    storeCredit: {
      label: function(d) { return "Store Credit Used"; },
      description: function(d) { return "If you have store credit available, it will be automatically deducted"; },
      amount: function(d) { return " -" + d.amount; }
    },
    applePay: function(d) { return "Apple Pay"; },
    applePayBrandLabel: function(d) { return "THE OUTNET"; },
    errors: {
      invalidAddress: function(d) { return "Please select your Billing Address"; },
      invalidPaymentMethod: function(d) { return "Please select a payment method"; }
    },
    expiredInfo: function(d) { return "We are sorry this payment option has expired. Please choose another"; },
    addPayment: function(d) { return "Add new payment"; },
    changePayment: function(d) { return "Change payment"; }
  },
  billingAddressForm: {
    title: function(d) { return "Billing Address"; },
    edit: function(d) { return "Edit my Billing Address"; },
    add: function(d) { return "Add Billing Address"; }
  },
  shippingAddressForm: {
    addressTitle: function(d) { return "Shipping Details"; },
    shipTo: function(d) { return "ship to"; },
    changeAddress: function(d) { return "Change Address"; },
    optionsTitle: function(d) { return "Shipping Options"; },
    title: function(d) { return "Shipping Address"; },
    enter: function(d) { return "Enter your Shipping Address"; },
    edit: function(d) { return "Edit my Shipping Address"; },
    add: function(d) { return "Add Shipping Address"; },
    keepAddress: function(d) { return "Use this address"; },
    temporaryAddress: function(d) { return "This address is temporary and will not be saved"; }
  },
  shippingOptionsForm: {
    title: function(d) { return "Shipping Options"; },
    deliveryOptionsUnavailable: function(d) { return "Unfortunately, the following shipping options are currently unavailable."; },
    signatureMandatory: function(d) { return "Make sure someone is available to sign for your purchase on delivery"; },
    noSignatureDisclaimer: function(d) { return "Deliver my package without collecting a signature. I accept responsibility for any loss or damage that may occur"; },
    submit: function(d) { return "Continue"; },
    selectDay: function(d) { return "Select Day"; },
    relativeDay: {
      today: function(d) { return "Today, "; },
      tomorrow: function(d) { return "Tomorrow, "; }
    },
    option: function(d) { return "option"; },
    errors: {
      outOfJuristdiction: function(d) { return "Cannot use an address outside of your country"; },
      packagingOptionInvalid: function(d) { return "Invalid packaging option"; },
      invalidShippingMode: function(d) { return "Sorry this shipping method is no longer available"; }
    },
    shippingOptionChanged: function(d) { return "Please review your order as your shipping options have changed"; }
  },
  shippingOptionsStep: {
    signatureRequired: function(d) { return "Signature on Delivery"; }
  },
  promotionForm: {
    code: function(d) { return "Promo Code"; },
    label: function(d) { return "Promo Code"; },
    apply: function(d) { return "Apply"; },
    title: function(d) { return "Add a Promo Code"; },
    openTitle: function(d) { return "Enter your Promo Code"; }
  },
  totals: {
    itemTotal: function(d) { return "Sub-Total"; },
    cashOnDelivery: function(d) { return "Cash on Delivery"; },
    shipping: function(d) { return "Shipping"; },
    zeroShippingPrice: function(d) { return "FREE"; },
    packaging: function(d) { return "Packaging"; },
    total: function(d) { return "Total"; },
    remove: function(d) { return ""; },
    removeButtonLabel: function(d) { return "Remove"; },
    tax: function(d) { return "Tax"; },
    shippingTax: function(d) { return "Shipping Tax"; },
    duty: function(d) { return "Taxes & Duties"; },
    shoppingBagDDPInfo: function(d) { return select(d.country, { CA: "We'll add all applicable taxes and/or duties once you select your address", other: "Any applicable taxes and/or duties have been applied to your Bag" }); },
    amTaxInfo: function(d) { return "Local taxes may apply at checkout"; },
    dduInfo: function(d) { return "I accept to pay any applicable taxes and/or duties when my order arrives at customs."; },
    storeCreditLabel: function(d) { return "Store Credit"; },
    storeCredit: function(d) { return "-" + d.storeCredit; },
    promoApplied: function(d) { return "Promo Applied"; },
    savingsTotal: function(d) { return "You're saving "; },
    brokerage: function(d) { return "Local customs fee"; },
    savingsExplanation: function(d) { return "Calculated against the RRP or, for exclusive collections, against the original price"; }
  },
  orderConfirmation: {
    thankyou: function(d) { return "Thank you " + d.firstName; },
    orderRef: function(d) { return " your order " + d.orderRef + " is on its way."; },
    email: function(d) { return "You will receive an email confirmation shortly at"; },
    shippingTo: function(d) { return "Shipping to"; },
    shippingMethod: function(d) { return "Shipping Method"; },
    billedTo: function(d) { return "Billed to"; },
    continueShopping: function(d) { return "Continue Shopping"; },
    showOrderDetails: function(d) { return "Show Your Order Details"; },
    delay: function(d) { return "Please note, you may experience a delay in receiving your order confirmation email. Simply sign into your account to see your order details in the meantime"; },
    showDetails: function(d) { return "Show order details"; }
  },
  orderReview: {
    summaryTitle: function(d) { return "Order Summary"; },
    title: function(d) { return "Order Details (" + plural(d.numItems, 0, en, { "1": "1 item", other: number(d.numItems, "numItems") + " items" }) + ")"; },
    checkout: function(d) { return "Buy Now"; },
    DDPTitle: function(d) { return "Includes all taxes and/or duties"; },
    dduMessage: function(d) { return "By placing this order, I agree to pay any applicable taxes and/or duties when it arrives at customs"; },
    DDPCountryInfo: function(d) { return "The total you pay at checkout includes all applicable taxes and/or duties. You won't incur any further charges when your purchase is delivered"; },
    sidebarTitle: function(d) { return "Your order (" + d.quantity + ")"; },
    continueAndBuy: function(d) { return "Continue and Buy"; }
  },
  authoriseStep: {
    processingPayment: function(d) { return "We're processing your payment – nearly done!"; }
  },
  product: {
    viewMoreDetails: function(d) { return "View more details"; },
    soldOut: function(d) { return "Sold out"; },
    unavailableOnline: function(d) { return "This item isn't available for purchase online, please contact Customer Care for more information"; },
    shippingRestriction: function(d) { return "Due to a shipping restriction, we're unable to deliver this item to your location"; },
    productCode: function(d) { return "Product Code"; },
    infoUnavailable: function(d) { return "Sorry, we can't find this information right now"; },
    buyableFalse: function(d) { return "Sorry, this item isn’t available for purchase"; },
    notStockedOnLine: function(d) { return "Sorry, this item isn't available for purchase"; },
    restrictedToEip: function(d) { return "Sorry, this item is currently unavailable. Keep track of this style by adding it to your Wish List"; },
    doNotForgetToAddToWishlistMessage: function(d) { return "Don’t forget to add your item to the Wish List"; },
    shippingRestrictionsNotificationMessage: function(d) { return "Shipping restrictions may apply. [Find out more](/" + d.locale + "/content/help/delivery/)"; },
    needAdvice: function(d) { return "Need advice?"; },
    needAdviceCTA: function(d) { return "Contact Customer Care"; },
    finalSaleNotification: function(d) { return "Final Sale - This item is non-returnable"; },
    settlementInAdvance: function(d) { return ""; },
    settlementResolve: function(d) { return ""; }
  },
  colourAndSize: {
    colour: function(d) { return "Color"; },
    size: function(d) { return "size"; },
    moreColours: function(d) { return "+ more"; }
  },
  sizes: {
    sizeLabel: function(d) { return "Size"; },
    oneSizeLabel: function(d) { return "One Size"; },
    initialValue: function(d) { return "Select one..."; }
  },
  quantity: {
    ctaButtons: {
      addQuantity: function(d) { return "Add one"; },
      subtractQuantity: function(d) { return "Remove one"; }
    }
  },
  ctaButtons: {
    addToBag: function(d) { return "Update"; },
    goToBag: function(d) { return "Go Back"; },
    viewShoppingBag: function(d) { return "View Shopping Bag"; },
    add: function(d) { return "Add to Bag"; },
    viewRecommendations: function(d) { return "View recommendations"; }
  },
  checkout: {
    errors: {
      outOfStock: function(d) { return "Sorry, one or more items in your Shopping Bag have sold out."; }
    }
  },
  paymentCodes: {
    addGiftCard: function(d) { return "Add MR PORTER Gift Card"; },
    addGiftCardInstructions: function(d) { return "To add a Gift Card please contact customer service on " + d.styledCustomerCarePhoneNumber; },
    fallbackCustomerCarePhoneNumber: function(d) { return ""; },
    addPromoCode: function(d) { return "Add Promo Code"; },
    promoCodeApplied: function(d) { return "Promo Code applied"; },
    remove: function(d) { return "Remove"; },
    checkActivePromos: function(d) { return "Check active promos"; }
  },
  loginConsent: {
    title: function(d) { return "Changes on our Site"; },
    overlayBody1: function(d) { return "We've updated our Account Terms & Conditions and Privacy Policy since you last visited our site. Please read below and agree before proceeding."; },
    overlayBody2: function(d) { return "By clicking agree you confirm to have read and understood our Account Terms and Conditions & Privacy Policy."; },
    pleaseNote1: function(d) { return "Please Note if you"; },
    dontProceed: function(d) { return "don't agree"; },
    pleaseNote2: function(d) { return "we won't be able to complete your registration and you'll need to continue as a guest. The Terms and Conditions and Privacy Policy will still apply if you check out as a guest."; },
    termsAndConditions: function(d) { return "Terms and Conditions"; },
    privacyPolicy: function(d) { return "Privacy Policy"; },
    submit: function(d) { return "Agree"; },
    and: function(d) { return "and"; }
  },
  languages: {
    en: function(d) { return "English"; },
    ar: function(d) { return "اللغة العربية"; },
    de: function(d) { return "Deutsche"; },
    fr: function(d) { return "Française"; },
    ja: function(d) { return "Japanese"; },
    ko: function(d) { return "Korean"; }
  },
  tcOverlay: {
    title: function(d) { return "YOOX NET-A-PORTER Group S.p.A. and The Net-A-Porter Group Limited collect and use your personal information as follows:"; },
    footer: function(d) { return "For further information, please read our [Privacy Policy](/" + d.locale + "/page/help/privacy-policy/)."; },
    newsletterTitle: function(d) { return "We collect and use your personal information as follows:"; },
    newsletterFooter: function(d) { return "*LuxExperience B.V. includes the following brands: Mr Porter, Mytheresa, Net-A-Porter, The Outnet, YOOX.\n\nWhen you visit, use our websites and/or applications, including services provided thereon, your information will be processed in accordance with the respective Privacy Policy of each brand: [Mr Porter](https://www.mrporter.com/content/help/privacy-policy/), [Mytheresa](https://www.mytheresa.com/to/service/privacy-policy), [Net-A-Porter](https://www.net-a-porter.com/content/help/privacy-policy/), [The Outnet](https://www.theoutnet.com/page/policies/privacy-policy/), [YOOX](https://www.yoox.com/Legal/Privacypolicy)."; }
  },
  tcParagraphs: {
    pg1: function(d) { return "Purposes of collection and use of personal information: identification of users; verification of eligibility for subscription; prevention of fraudulent subscription and fraud; execution and performance of purchase agreements for products; provision of services provided by the website and the Apps; response to customer requests and inquiries; exercise or defense of legal claims, statistical analysis and survey; and performance of obligations under applicable laws and regulations."; },
    pg2: function(d) { return "Items of Personal Information to be collected."; },
    pg3: function(d) { return "[When signing up for membership] Name, surname, email address, password, service usage history and, if provided by the user, date of birth, gender and phone number."; },
    pg4: function(d) { return "[When purchasing products] Order history, delivery address, invoice address, phone number, payment details."; },
    pg5: function(d) { return "Period of retention and use of personal information: Information collected at the time of membership registration will be retained and used until a request for withdrawal is made, and information collected to conclude and execute a purchase contract for a product will be stored in accordance with applicable tax legislation until the conclusion of all administrative and accounting formalities (ten years)."; }
  },
  newsletterTcParagraphs: {
    pg1: function(d) { return "Purpose of collection and use of personal information: Transmission of newsletters and advertisements, customised promotional and marketing communications via email from LuxExperience B.V.* brands to improve user shopping experience."; },
    pg2: function(d) { return "Items of personal information to be collected: Name, email address, gender, date of birth, phone number, order history, browsing habits."; },
    pg3: function(d) { return "Period of retention and use of personal information: To the extent permitted by applicable laws and regulations, personal information will be processed until you withdraw your consent or request your membership withdrawal or, with specific regard to the customisation of the communications, you disable the cookies. Any other information required to be preserved under applicable laws and regulations shall be preserved for the period set forth under such laws and regulations."; }
  },
  help: {
    passwordRules: function(d) { return "Your password must be eight characters or more and contain an uppercase letter and number"; }
  }
}